module.exports = __webpack_public_path__ + "assets/user.f5fdab9a.svg";